import { FC } from 'react';
import { observer } from 'mobx-react';
import { generatePath, Link } from 'react-router-dom';
import { useConfirm } from '@servicetitan/confirm';
import { useDependencies } from '@servicetitan/react-ioc';
import { Button, Stack } from '@servicetitan/design-system';
import { IPartition } from '@servicetitan/marketing-tenant-management-api';
import { withRoot } from '../../../utils/with-root';
import { ConfirmDeleteDialog } from '../confirm-delete-dialog';
import { AccountManagementRoutes } from '../../../utils/routes';
import { PartitionsStore } from '../../../stores/partitions.store';
import { TableCellDataProps } from '../../../../common/utils/types';

export const ActionsCell: FC<TableCellDataProps<IPartition>> = observer(
    ({ style, colSpan, className, ariaColumnIndex, dataItem }) => {
        const [{ deletePartition, tenantDetails }] = useDependencies(PartitionsStore);

        const isCorporate = !dataItem.externalId;

        const relativePath = !isCorporate
            ? generatePath(AccountManagementRoutes.managePartition, {
                  externalPartnerId: tenantDetails.partnerId,
                  externalTenantId: tenantDetails.externalId,
                  externalPartitionId: dataItem.externalId,
              })
            : undefined;

        const [ConfirmDelete, handleDeleteClick] = useConfirm(() =>
            deletePartition(dataItem.internalId),
        );

        const manageButton = (
            <Button size="xsmall" disabled={isCorporate}>
                Manage
            </Button>
        );

        return (
            <td
                colSpan={colSpan}
                style={{ ...style }}
                className={className}
                aria-colindex={ariaColumnIndex}
            >
                <Stack justifyContent="center" spacing={1}>
                    {!isCorporate && relativePath ? (
                        <Link to={withRoot(relativePath)}>{manageButton}</Link>
                    ) : (
                        manageButton
                    )}
                    <Button
                        text
                        size="xsmall"
                        iconName="delete"
                        disabled={isCorporate}
                        onClick={handleDeleteClick}
                    />
                </Stack>
                <ConfirmDelete confirmation={ConfirmDeleteDialog} />
            </td>
        );
    },
);
